import { render, staticRenderFns } from "./MultipleSidebar.vue?vue&type=template&id=7159ee92&scoped=true"
import script from "./MultipleSidebar.vue?vue&type=script&lang=js"
export * from "./MultipleSidebar.vue?vue&type=script&lang=js"
import style0 from "./MultipleSidebar.vue?vue&type=style&index=0&id=7159ee92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7159ee92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7159ee92')) {
      api.createRecord('7159ee92', component.options)
    } else {
      api.reload('7159ee92', component.options)
    }
    module.hot.accept("./MultipleSidebar.vue?vue&type=template&id=7159ee92&scoped=true", function () {
      api.rerender('7159ee92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/repositorio/MultipleSidebar.vue"
export default component.exports